import { render } from "./ActivitePage.vue?vue&type=template&id=5d5905c5"
import script from "./ActivitePage.vue?vue&type=script&lang=js"
export * from "./ActivitePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__